import axios from "axios";

export const state = {
    customers: [],
    customer_balances: {},
    customer_deposits: [],
    customer_refunds: [],
    customer_sales: [],
    save_status: false,
    customer_balancedetails: [],
    customer_locations:[],
    depositId: '',
    missed_customers:'',
    filter_status:''
};
export const getters = {
    Customers: state => state.customers.data,
    CustomerBalances: state => state.customer_balances,
    CustomerBalanceDetails: state => state.customer_balancedetails.data,
    CustomerDeposits: state => state.customer_deposits.data,
    CustomerRefunds: state => state.customer_refunds.data,
    CustomerSales: state => state.customer_sales.data,
    SaveStatus: state => state.save_status,
    DepositID: state => state.depositId,
    MissedCustomers: state => state.missed_customers.data,
    CustomerLocations: state => state.customer_locations.data,
    filterStatus: state => state.filter_status
};
export const mutations = {
    SET_CUSTOMERS(state, newValue) {
        state.customers = newValue
    },
    SET_CUSTOMER_BALANCES(state, newValue) {
        state.customer_balances = newValue
    },
    SET_CUSTOMER_DEPOSITS(state, newValue) {
        state.customer_deposits = newValue
    },
    SET_CUSTOMER_REFUNDS(state, newValue) {
        state.customer_refunds = newValue
    },
    SET_SAVE_STATUS(state, newValue) {
        state.save_status = newValue
    },
    SET_CUSTOMER_BALANCEDETAILS(state, newValue) {
        state.customer_balancedetails = newValue
    },
    SET_CUSTOMER_SALES(state, newValue) {
        state.customer_sales = newValue
    },
    SET_DEPOSIT_ID(state, newValue) {
        state.depositId = newValue
    },
    SET_MISSED_CUSTOMERS(state, newValue) {
        state.missed_customers = newValue
    },    
    SET_CUSTOMER_LOCATIONS(state, newValue) {
        state.customer_locations = newValue
    },
    SET_FILTER_STATUS(state, newValue) {
        state.filter_status = newValue
    },
};
export const actions = {
    addCustomer({ commit, dispatch }, payload) {
        commit('SET_SAVE_STATUS', true);
        axios.post('customers', payload).then(() => {
            dispatch('fetchCustomers');
            // let message = { 'msg': ` Customer ${payload.name}  with Contact ${payload.contact} added successfully` }
            let message = { 'msg': ` Customer added successfully` }
            dispatch('notification/success', message, { root: true })
            commit('SET_SAVE_STATUS', false);
        }).catch(() => {
            commit('SET_SAVE_STATUS', false)
            let message = { 'msg': "Error Adding Customer " }
            dispatch('notification/error', message, { root: true })
        })
    },
    deleteCustomer({ commit, dispatch }, payload) {
        commit('SET_SAVE_STATUS', true);
        axios.delete(`customers/${payload.id}`).then(() => {
            dispatch('fetchCustomers');
            let message = { 'msg': `Customer  record deleted successfully` }
            dispatch('notification/success', message, { root: true })
            commit('SET_SAVE_STATUS', false);
        }).catch((error) => {
            commit('SET_SAVE_STATUS', false)
            let message = { 'msg': "Error " + error }
            dispatch('notification/error', message, { root: true })
        })
    },
    // Edit customer
    editCustomer({ commit, dispatch }, payload) {
        commit('SET_SAVE_STATUS', true);
        axios.put(`customers/${payload.id}`, payload).then(() => {
            dispatch('fetchCustomers');
            let message = { 'msg': `Details of Customer ${payload.name} updated successfully` }
            dispatch('notification/success', message, { root: true })
            commit('SET_SAVE_STATUS', false);
        }).catch((error) => {
            commit('SET_SAVE_STATUS', false)
            let message = { 'msg': "Error updating Customer Details " + error }
            dispatch('notification/error', message, { root: true })
        })
    },
    // add customer deposit
    addCustomerDeposit({ commit, dispatch }, payload) {
        commit('SET_SAVE_STATUS', true);
        axios.post('customer_deposit', payload).then((response) => {
            if (response.data.status == 200) {
                let message = { 'msg': ` Customer deposit of ${payload.amount}  recorded successfully` }
                dispatch('notification/success', message, { root: true });
            } else if (response.data.status == 202) {
                let message = { 'msg': "Failed to record Deposit" }
                dispatch('notification/error', message, { root: true })
            }
            dispatch('fetchCustomerDepositReport', payload.filterdata);
            commit('SET_SAVE_STATUS', false);
        }).catch(() => {
            commit('SET_SAVE_STATUS', false)
            let message = { 'msg': "Error Adding Customer Deposit " }
            dispatch('notification/error', message, { root: true })
        })
    },
    // Edit customer Deposit
    editCustomerDeposit({ commit, dispatch }, payload) {
        commit('SET_SAVE_STATUS', true);
        axios.put(`customer_deposit/${payload.id}`, payload).then(() => {
            dispatch('fetchCustomerDepositReport', payload.filterdata);
            let message = { 'msg': `Customer Deposit Updated Successfully` }
            dispatch('notification/success', message, { root: true })
            commit('SET_SAVE_STATUS', false);
        }).catch((error) => {
            commit('SET_SAVE_STATUS', false)
            let message = { 'msg': "Error updating Customer Depsoit " + error }
            dispatch('notification/error', message, { root: true })
        })
    },
    // delete customer deposit
    deleteCustomerDeposit({ commit, dispatch }, payload) {
        commit('SET_SAVE_STATUS', true);
        axios.delete(`customer_deposit/${payload.id}`).then(() => {
            dispatch('fetchCustomerDepositReport', payload.filterdata);
            let message = { 'msg': `Customer Deposit  record deleted successfully` }
            dispatch('notification/success', message, { root: true })
            commit('SET_SAVE_STATUS', false);
        }).catch((error) => {
            commit('SET_SAVE_STATUS', false)
            let message = { 'msg': "Error " + error }
            dispatch('notification/error', message, { root: true })
        })
    },
    // Fetch customer Deposits
    fetchCustomerDeposits({ commit }) {
        axios.get('customer_deposit').then(ec_res => {
            commit('SET_CUSTOMER_DEPOSITS', ec_res.data)
        })
    },

    fetchCustomerDepositsDetails({ commit }, id) {
        axios.get(`customerdeposit_details/${id}`).then(ec_res => {
            commit('SET_CUSTOMER_DEPOSITS', ec_res.data)
        })
    },

    // Fetch customers

    fetchCustomers({ commit }) {
        axios.get('customers').then(ec_res => {
            commit('SET_CUSTOMERS', ec_res.data)
        })
    },
    // customer balances
    fetchCustomerBalances({ commit }, payload) {
        axios.post('customer_balances', payload).then(ec_res => {
            commit('SET_CUSTOMER_BALANCES', ec_res.data)
        })
    },

    // customer balances details
    fetchCustomerBalanceDetails({ commit }, payload) {
        commit('SET_FILTER_STATUS',true)
        axios.post('customer_balancedetails',payload).then(response => {   
            commit('SET_CUSTOMER_BALANCEDETAILS', response.data)
            commit('SET_FILTER_STATUS',false)
        })
    },

    fetchDescriptiveCustomerBalanceDetails({ commit }, id) {
        axios.get(`descriptive_customerbalancedetails/${id}`).then(ec_res => {
            commit('SET_CUSTOMER_BALANCEDETAILS', ec_res.data)
        })
    },

    // customer balances details
    fetchCustomerSales({ commit }, payload) {
        axios.post('customer_sales', payload).then(ec_res => {
            commit('SET_CUSTOMER_SALES', ec_res.data)
        })
    },

    // Fetch customer Deposits
    fetchCustomerRefunds({ commit }) {
        axios.get('customer_refund').then(ec_res => {
            commit('SET_CUSTOMER_REFUNDS', ec_res.data)
        })
    },

    fetchCustomerRefundsDetails({ commit }, id) {
        axios.get(`customer_refund/${id}`).then(ec_res => {
            commit('SET_CUSTOMER_REFUNDS', ec_res.data)
        })
    },

    // add customer deposit
    addCustomerRefund({ commit, dispatch }, payload) {
        commit('SET_SAVE_STATUS', true);
        axios.post('customer_refund', payload).then((response) => {
            if (response.data.status == 200) {
                let message = { 'msg': ` Customer refund of ${payload.amount}  recorded successfully` }
                dispatch('notification/success', message, { root: true });
            } else if (response.data.status == 202) {
                let message = { 'msg': "Failed to record Refund" }
                dispatch('notification/error', message, { root: true })
            }
            dispatch('fetchCustomerRefunds');
            commit('SET_SAVE_STATUS', false);
        }).catch(() => {
            commit('SET_SAVE_STATUS', false)
            let message = { 'msg': "Error Adding Customer Refund " }
            dispatch('notification/error', message, { root: true })
        })
    },

    // Edit customer Deposit
    editCustomerRefund({ commit, dispatch }, payload) {
        commit('SET_SAVE_STATUS', true);
        axios.put(`customer_refund/${payload.id}`, payload).then(() => {
            dispatch('fetchCustomerRefunds');
            let message = { 'msg': `Customer Refund Updated Successfully` }
            dispatch('notification/success', message, { root: true })
            commit('SET_SAVE_STATUS', false);
        }).catch((error) => {
            commit('SET_SAVE_STATUS', false)
            let message = { 'msg': "Error updating Customer Refund " + error }
            dispatch('notification/error', message, { root: true })
        })
    },

    // delete customer deposit
    deleteCustomerRefund({ commit, dispatch }, payload) {
        commit('SET_SAVE_STATUS', true);
        axios.delete(`customer_refund/${payload.id}`).then(() => {
            dispatch('fetchCustomerRefunds');
            let message = { 'msg': `Customer Refund  record deleted successfully` }
            dispatch('notification/success', message, { root: true })
            commit('SET_SAVE_STATUS', false);
        }).catch((error) => {
            commit('SET_SAVE_STATUS', false)
            let message = { 'msg': "Error " + error }
            dispatch('notification/error', message, { root: true })
        })
    },

    // Merge Customers
    mergeCustomer({ commit, dispatch }, payload) {
        commit('SET_SAVE_STATUS', true);
        axios.post(`map_customer/${payload.id}`, payload).then(() => {
            dispatch('fetchCustomers');
            let message = { 'msg': `Customer ${payload.name} merged successfully` }
            dispatch('notification/success', message, { root: true })
            commit('SET_SAVE_STATUS', false);
        }).catch(() => {
            commit('SET_SAVE_STATUS', false)
            let message = { 'msg': "Error merging Customers" }
            dispatch('notification/error', message, { root: true })
        })
    },
    // Reorder Sale
    reorderSale({ commit, dispatch }, payload) {
        commit('SET_SAVE_STATUS', true);
        axios.put(`reorder_sale/${payload.id}`, payload).then((response) => {
            // alert(response.status);
            if (response.status == 200) {
                let message = { 'msg': `Items Added to Cart Successfully` }
                dispatch('notification/success', message, { root: true });
            } else if (response.status == 202) {
                let message = { 'msg': "Failed , You have incomplete sale items in Cart" }
                dispatch('notification/error', message, { root: true })
            }
            commit('SET_SAVE_STATUS', false)
        }).catch((error) => {
            commit('SET_SAVE_STATUS', false)
            let message = { 'msg': "Error updating Customer Refund " + error }
            dispatch('notification/error', message, { root: true })
        })
    },

    // Fetch customer Deposits
    fetchCustomerDepositReport({ commit }, payload) {
        commit('SET_FILTER_STATUS', true)
        axios.post('customer_depositreport', payload).then(ec_res => {
            commit('SET_FILTER_STATUS', false)
            commit('SET_CUSTOMER_DEPOSITS', ec_res.data)
        })
    },

    // Missed customers
    fetchMissedCustomers({ commit }) {
        axios.get('missed_customers').then(ec_res => {
            commit('SET_MISSED_CUSTOMERS', ec_res.data)
        })
    },
    // addMissedCustomer
    addMissedCustomer({ commit, dispatch }, payload) {
        commit('SET_SAVE_STATUS', true);
        axios.post('missed_customers', payload).then(() => {
            dispatch('fetchMissedCustomers');
            let message = { 'msg': ` Missed Customer recorded successfully` }
            dispatch('notification/success', message, { root: true })
            commit('SET_SAVE_STATUS', false);
        }).catch(() => {
            commit('SET_SAVE_STATUS', false)
            let message = { 'msg': "Error Adding Missed Customer " }
            dispatch('notification/error', message, { root: true })
        })
    },

    // Edit Missed customer
    editMissedCustomer({ commit, dispatch }, payload) {
        commit('SET_SAVE_STATUS', true);
        axios.put(`missed_customers/${payload.id}`, payload).then(() => {
            dispatch('fetchMissedCustomers');
            let message = { 'msg': `Missed Customer ${payload.name} Updated Successfully` }
            dispatch('notification/success', message, { root: true })
            commit('SET_SAVE_STATUS', false);
        }).catch((error) => {
            commit('SET_SAVE_STATUS', false)
            let message = { 'msg': "Error updating Missed Customer " + error }
            dispatch('notification/error', message, { root: true })
        })
    },

    // delete Missed customer 
    deleteMissedCustomer({ commit, dispatch }, payload) {
        commit('SET_SAVE_STATUS', true);
        axios.delete(`missed_customers/${payload.id}`).then(() => {
            dispatch('fetchMissedCustomers');
            let message = { 'msg': `Missed Customer ${payload.name}  record deleted successfully` }
            dispatch('notification/success', message, { root: true })
            commit('SET_SAVE_STATUS', false);
        }).catch((error) => {
            commit('SET_SAVE_STATUS', false)
            let message = { 'msg': "Error Deleting Missed Customer " + error }
            dispatch('notification/error', message, { root: true })
        })
    },

    // Fetch customer Locations
    fetchCustomerLocations({ commit }) {
        axios.get('customer_locations').then(ec_res => {
            commit('SET_CUSTOMER_LOCATIONS', ec_res.data)
        })
    },

    // Add Customer Location
    addCustomerLocation({ commit, dispatch }, payload) {
        commit('SET_SAVE_STATUS', true);
        axios.post('customer_locations', payload).then(() => {
            dispatch('fetchCustomerLocations');
            let message = { 'msg': ` Customer location ${payload.name} added successfully` }
            dispatch('notification/success', message, { root: true })
            commit('SET_SAVE_STATUS', false);
        }).catch(() => {
            commit('SET_SAVE_STATUS', false)
            let message = { 'msg': "Error Adding Customer location" }
            dispatch('notification/error', message, { root: true })
        })
    },

    // Edit customer location
    editCustomerLocation({ commit, dispatch }, payload) {
        commit('SET_SAVE_STATUS', true);
        axios.put(`customer_locations/${payload.id}`, payload).then(() => {
            dispatch('fetchCustomerLocations');
            let message = { 'msg': `Customer location ${payload.name} updated Successfully` }
            dispatch('notification/success', message, { root: true })
            commit('SET_SAVE_STATUS', false);
        }).catch((error) => {
            commit('SET_SAVE_STATUS', false)
            let message = { 'msg': "Error updating Customer location " + error }
            dispatch('notification/error', message, { root: true })
        })
    },

    // delete customer location 
    deleteCustomerLocation({ commit, dispatch }, payload) {
        commit('SET_SAVE_STATUS', true);
        axios.delete(`customer_locations/${payload.id}`).then(() => {
            dispatch('fetchCustomerLocations');
            let message = { 'msg': `Customer location ${payload.name} deleted successfully` }
            dispatch('notification/success', message, { root: true })
            commit('SET_SAVE_STATUS', false);
        }).catch((error) => {
            commit('SET_SAVE_STATUS', false)
            let message = { 'msg': "Error Deleting Customer location " + error }
            dispatch('notification/error', message, { root: true })
        })
    },


};